module.exports = __webpack_public_path__ + "static/media/icon-settings-white.93382c9b.svg";